import { useGlobalUser } from "@/stores/globalUser";
import { computed, ref } from "vue";
import { useLocalStorage } from "@vueuse/core";
import { useRouteQuery } from "@vueuse/router";

export const useDiscordGift = () => {
  const redeemCode = useRouteQuery("redeemCode", "");
  const giftLink = "https://discord.gg/9w7PvscpxE";
  const userStore = useGlobalUser();
  const shouldDisplay = ref(true);
  const showDiscordGiftLink = computed({
    get: () => shouldDisplay.value && !userStore.hasRedeemedGift,
    set: (v) => (shouldDisplay.value = v),
  });
  const isRedeeming = computed(() => redeemCode.value !== "");
  return {
    showDiscordGiftLink,
    giftLink,
    isRedeeming,
    redeemCode,
  };
};
